export enum OnboardingStage {
	Introduction,
	InProgress,
	Completed
}
